<!---------------------------->
<!-- Application Details:-->
<!---------------------------->

<div *ngIf="application">

  <section class="clearfix">
      <div class="flex justify-center col col-6">
        <div class="flex flex-column">
          <div class="col-12">
            <app-content-field [content]="application.applicationReferenceNumber || 'N/A'"
                               [label]="'Application Reference Number'"></app-content-field>
          </div>

          <div class="col-12">
            <app-content-field [content]="application.membership?.membershipNumber || 'N/A'"
                               [label]="'Membership Number'"></app-content-field>
          </div>

          <div class="col-12">
            <app-content-field
              [content]="getDisplayString(application.scheme?.schemeCode, application.scheme?.schemeName) || 'N/A'"
              [label]="'Scheme'"></app-content-field>
          </div>


          <div class="col-12">
            <ng-container *ngTemplateOutlet="inlineEditAutocomplete; context: {
              label: 'Policyholder Group',
              displayValue: getDisplayString(
                application?.employerGroup?.employerGroupCode,
                application?.employerGroup?.employerGroupName
              ),
              isEditing: editEmployerGroup,
              placeholder: 'Search by policyholder group by name OR number',
              options: filteredEmployerGroups,
              searchControl: employerGroupFormControl,
              onEdit: overrideEmployerGroupClicked.bind(this),
              onInput: onInputChangedSearchEmployerGroups.bind(this),
              onClear: clearEmployerGroupEdit.bind(this)
            }">
            </ng-container>
          </div>

          <div class="col-12">
            <app-content-field [content]="application.membership?.applicationDate | date:dateFormat || 'N/A'"
                               [label]="'Application Date'"></app-content-field>
          </div>

          <div class="col-12">
            <app-content-field
              [content]="getDisplayString(application.stage?.stageCode, application.stage?.stageName) || 'N/A'"
              [label]="'Stage'"></app-content-field>
          </div>

          <div class="col-12">
            <div class="flex items-center">
              <app-element-select class="full-width"
                                  displayLabel='Status'
                                  [defaultValue]="status"
                                  [options]="statuses"
                                  [disabled]="!hasReprocessPermissions"
                                  (selectionChanged)="statusSelected($event)">
              </app-element-select>
              <mat-icon (click)="openReasoningDialog(application?.status?.statusName); $event.stopPropagation()"
                        class="table-icon font-medium hand-cursor"
                        matTooltip="Update the justification">
                info
              </mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center col col-6">
        <div class="flex flex-column">

          <div class="col-12">
            <app-content-field [content]="application.batchReferenceNumber || 'N/A'"
                               [label]="'Batch Reference Number'"></app-content-field>
          </div>

          <div class="col-12">
            <app-content-field [content]="application.membership?.principalLastName || 'N/A'"
                               [label]="'Principal Last Name'"></app-content-field>
          </div>

          <div class="col-12">
            <app-content-field [content]="application.membership?.optionCode || 'N/A'"
                               [label]="'Product'"></app-content-field>
          </div>

          <div class="col-12">
            <ng-container *ngTemplateOutlet="inlineEditAutocomplete; context: {
              label: 'Broker',
              displayValue: getDisplayString(
                application?.intermediatory?.intermediatoryCode,
                application?.intermediatory?.intermediatoryName
              ),
              isEditing: editBroker,
              placeholder: 'Search by broker name OR number',
              options: filteredBrokers,
              searchControl: brokerFormControl,
              onEdit: overrideBrokerClicked.bind(this),
              onInput: onInputChangedSearchBrokers.bind(this),
              onClear: clearBrokerEdit.bind(this)
            }">
            </ng-container>
          </div>

          <div class="col-12">
            <ng-container *ngTemplateOutlet="inlineEditStartDate; context: {
              label: 'Start date',
              displayValue: getStartDateDisplayValue(),
              isEditing: editStartDate,
              options: startDateOptions,
              searchControl: startDateFormControl,
              onEdit: overrideStartDateClicked.bind(this),
              onClear: clearSaveDateEdit.bind(this)
            }">
            </ng-container>
     
      
          
          </div>

          <div class="col-12">
            <div class="flex hand-cursor items-center">
              <app-content-field
                [content]="formatValue(application.membership?.premiumTotal)"
                [label]="'Total Premium'">
              </app-content-field>
              <mat-icon (click)="onClickOpenPremiumCalculationDialog(); $event.stopPropagation()"
                        class="table-icon font-medium"
                        matTooltip="See how the premium was calculated">
                info
              </mat-icon>
            </div>
          </div>

             <div class="col-12">
    <mat-slide-toggle [checked]="application.preUnderwritingRequestIndicator"
                      [disabled]="!hasReprocessPermissions">
          Pre-Underwriting Request
        </mat-slide-toggle>
  </div>
        </div>
      </div>
  </section>

  <!---------------------------->
  <!-- Reprocess/View Results Buttons:-->
  <!---------------------------->
  <section class="clearfix">
    <div class="col col-6">
      <div class="flex items-center hand-cursor justify-center global-container">
        <button mat-raised-button
                [disabled]="!isAuthorisedToReprocess"
                (click)="onClickReprocessApplication($event)">
          {{isProcessing ? 'Processing...' : 'Reprocess'}}
        </button>
        <mat-icon class="info-icon"
                  *ngIf="!hasReprocessPermissions || isApplicationLocked"
                  [matTooltip]="reprocessingTooltip()">
          help_outline
        </mat-icon>
        <button class="m-l-15" color="primary"
                mat-raised-button
                *ngIf="canSendCommunicationPack()"
                (click)="sendCommunicationPack()">Send Communication Pack
        </button>
        <button class="m-l-15" color="primary"
                mat-raised-button
                (click)="onClickOpenReport($event,application?.applicationId)">View Results
        </button>
      </div>
    </div>
  </section>
</div>

<!---------------------------->
<!-- Person Details:-->
<!---------------------------->

<app-application-persons [application]="application"
                         [hasOnboardingRole]="hasReprocessPermissions"
                         [diagnosisGroups]="diagnosisGroups"
                         [isApplicationLocked]="isApplicationLocked"
                         (personsUpdated)="onPersonsUpdated($event)"
                         (dispatchFetchRequest)="handleUpdateRequest($event)">
</app-application-persons>

<!-- First define the reusable template -->
<ng-template #inlineEditAutocomplete
             let-label="label"
             let-displayValue="displayValue"
             let-isEditing="isEditing"
             let-placeholder="placeholder"
             let-options="options"
             let-searchControl="searchControl"
             let-onEdit="onEdit"
             let-onInput="onInput"
             let-onClear="onClear">

  <app-content-field *ngIf="!isEditing"
                     [content]="displayValue"
                     [label]="label"
                     [isEditable]="hasPermissions"
                     (editClick)="onEdit()">
  </app-content-field>

  <div *ngIf="isEditing" class="flex items-center edit-enabled-selection">
    <mat-form-field class="w-100">
      <mat-label>{{label}}</mat-label>
      <input matInput
             [formControl]="searchControl"
             [matAutocomplete]="auto"
             [placeholder]="placeholder"
             (input)="onInput($event)">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of options"
                    [value]="getDisplayString(option.policyholderGroupNumber || option.brokerNumber,option.name)"
                    (onSelectionChange)="onOptionSelected(option)">
          {{getDisplayString(option.policyholderGroupNumber || option.brokerNumber, option.name)}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div *ngIf="hasPermissions" class="flex items-center mt1">
      <mat-icon (click)="onClear()"
                class="font-medium"
                matTooltip="Cancel edit" style="color: grey;">
        cancel
      </mat-icon>
      <mat-icon (click)="onSave()"
                class="table-icon font-medium"
                [class.disabled]="!selectedOption"
                matTooltip="Save number">
        save
      </mat-icon>
    </div>
  </div>
</ng-template>


<ng-template #inlineEditStartDate
             let-label="label"
             let-displayValue="displayValue"
             let-isEditing="isEditing"
             let-options="options"
             let-searchControl="searchControl"
             let-onEdit="onEdit"
             let-onClear="onClear">

  <app-content-field *ngIf="!isEditing"
                     [content]="displayValue"
                     [label]="label"
                     [isEditable]="hasPermissions"
                     (editClick)="onEdit()">
  </app-content-field>

  <div *ngIf="isEditing" class="flex items-center edit-enabled-selection">
    <mat-form-field class="w-100">
        <mat-label>Membership Start Date</mat-label>
        <mat-select [formControl]="searchControl">
          <mat-option *ngFor="let option of options" [value]="option.value">
            {{ option.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    <div *ngIf="hasPermissions" class="flex items-center mt1">
      <mat-icon (click)="onClear()"
                class="font-medium"
                matTooltip="Cancel edit" style="color: grey;">
        cancel
      </mat-icon>
      <mat-icon (click)="onSave()"
                class="table-icon font-medium"
                [class.disabled]="isStartDateSave"
                matTooltip="Save number">
        save
      </mat-icon>
    </div>
  </div>
</ng-template>


